import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ExportFinancialService } from "../models/export-financial-service.model";
import { Report } from "../models/report.model";
import { ExportGeneration } from "../models/exportGeneration";
import { Response } from "../models/response.model";
import { AppState } from "../state/app.state";
import { ExportDownloadType } from "../models/export-download-type.model";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class ExportFinancialServiceService {
  constructor(private http: HttpClient, private appState: AppState) {}

  getExportFinancialServiceList(): Observable<ExportFinancialService[]> {
    return this.http
      .get<Response>(`${this.appState.baseApiUrl}/exports/financial-service`, httpOptions)
      .pipe(map((response: Response) => response.Data));
  }

  getExportFinancialServiceDetail(id: number): Observable<ExportFinancialService> {
    return this.http
      .get<Response>(`${this.appState.baseApiUrl}/exports/financial-service/${id}`, httpOptions)
      .pipe(map((response: Response) => response.Data));
  }

  generateExport(exportGeneration: ExportGeneration): Observable<Response> {
    return this.http.post<Response>(
      `${this.appState.baseApiUrl}/exports/financial-service/generate-export`,
      exportGeneration,
      httpOptions,
    );
  }

  regenerateExport(id: number): Observable<Response> {
    return this.http.post<Response>(`${this.appState.baseApiUrl}/exports/financial-service/generate-export/${id}`, httpOptions);
  }

  deleteExport(id: number): Observable<Response> {
    return this.http.delete<Response>(`${this.appState.baseApiUrl}/exports/financial-service/${id}`, httpOptions);
  }

  downloadExport(id: number): Observable<any> {
    return this.http.get(`${this.appState.baseApiUrl}/exports/financial-service/${id}/download`, { responseType: "blob" });
  }

  updateExportDetail(exportUpdateModel: ExportFinancialService): Observable<Response> {
    return this.http.post<Response>(
      `${this.appState.baseApiUrl}/exports/financial-service/${exportUpdateModel.Id}`,
      exportUpdateModel,
      httpOptions,
    );
  }

  handleFoutLine(id: number, isHandled: boolean): Observable<Response> {
    return this.http.post<Response>(
      `${this.appState.baseApiUrl}/exports/financial-service/fouten/handle/${id}/${isHandled}`,
      httpOptions,
    );
  }

  getDownloadTypes(): Observable<ExportDownloadType[]> {
    return this.http.get<ExportDownloadType[]>(
      `${this.appState.baseApiUrl}/exports/financial-service/download-types`,
      httpOptions,
    );
  }
}
